exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".has-danger-custom {\n  border: 1px solid red; }\n\n.has-success-custom {\n  border: 1px solid limegreen; }\n\n.header-section {\n  background-color: #F6F6F6;\n  padding-top: 10px;\n  padding-bottom: 4px;\n  margin-bottom: 9px; }\n\n.margin-left-h5 {\n  padding-left: 15px; }\n\n.input-group-prepend {\n  background-color: white; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src14910448/src/src/app/components/businessRules/businessRules.component.scss
// module id = ../../../../../src/app/components/businessRules/businessRules.component.scss
// module chunks = main